module.exports = __webpack_public_path__ + "9fd33400595e79478494f34b7cfd7fc9.svg";